 /*	MARK: Profile
	============================================
 */
import { inject, PLATFORM } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService } from '../services/data-service';

@inject(DataService, Router)
export class Profile {
	/** Component methods **/
	constructor(ds, router){
		this.ds		= ds;
		this.router	= router;
		// component model
		this.user_info = { name:null, last_name:null, username:null, email:null}
	}

	activate(params){}

	attached(){
		// Init function
		window.setTimeout( () => { this.init(); }, 600 );
	}

	/** Custom methods **/
	init(){
		if(!this.ds.user_info){
			// Get remote user info
			this.ds.getUserInfo().then(res => {
				this.user_info 		= res.data;
				this.ds.user_info 	= res.data;
			});
		}
		else{
			// Procede
			this.user_info = this.ds.user_info;
		}
	}
	
}
